import {events} from '../events';

export const setTermsAndConditions = ({path, iAgree}) => ({
    type: events.TERMS_AND_CONDITIONS_SET,
    payload: {
        [path]: iAgree
    }
});
